import styled from '@emotion/styled';

export const Container = styled.div<{ showAnimation?: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  padding: 5px;
  box-shadow: -5px 5px 5px 0px rgba(0, 0, 0, 0.1);
  cursor: pointer;
  transition: transform 0.3s ease;
  border-radius: 2px;
  &:hover {
    box-shadow: ${(props) =>
      props.showAnimation
        ? '-5px 5px 5px 0px rgba(0, 0, 0, 0.2)'
        : '-5px 5px 5px 0px rgba(0, 0, 0, 0.1);'};
    transform: ${(props) =>
      props.showAnimation ? 'translate(2px, -2px)' : 'none'};
  }
`;

export const imageStyle = { minWidth: '100px', minHeight: '100px' };
